import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reported-community',
  templateUrl: './reported-community.component.html',
  styleUrls: ['./reported-community.component.scss']
})
export class ReportedCommunityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
